import { render, staticRenderFns } from "./LoginDialog.vue?vue&type=template&id=10af9c1c&scoped=true&"
import script from "./LoginDialog.vue?vue&type=script&lang=js&"
export * from "./LoginDialog.vue?vue&type=script&lang=js&"
import style0 from "./LoginDialog.vue?vue&type=style&index=0&id=10af9c1c&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10af9c1c",
  null
  
)

export default component.exports